<template>
	<div
		:class="
			id != 'panel-slot' && 'd-flex align-items-center justify-content-between'
		"
	>
		<label id="hideinmobile" v-if="!noLabel" class="teams-label-font w-40"
			>{{ label }}<span v-if="mandatory" class="asterik">*</span></label
		>
		<div class="w-100 position-relative">
			<Popper
				trigger="clickToToggle"
				:key="reRender"
				@show="openDropdown = true"
				@hide="openDropdown = false"
				:options="{
					preventOverflow: {
						enabled: true,
					},
					eventsEnabled: false,
				}"
			>
				<template>
					<div class="selectCustom-dropdown pointer">
						<div
							class="selectCustom-dropdown-innerContent"
							v-for="(opt, index) in dropDownOptions"
							:key="index"
							:id="opt.key"
							@click="
								(selectedObject = opt),
									(selectedValue = opt.key),
									$emit('select-value', selectedValue),
									hideLandingDropdown()
							"
							:class="{
								'selectCustom-opt-selected': isSelected(opt),
								'selectCustom-opt-unselected': !isSelected(opt),
							}"
						>
							{{ opt.label }}
						</div>
					</div>
				</template>
				<template slot="reference"
					><div
						class="selectCustom-field d-flex align-items-center justify-content-between selcus-floating-label-field"
						:class="{ error: showError }"
						@focus="isFocused = true"
						@blur="isFocused = false"
					>
						<span
							:class="{
								'inputPlaceholder-font': !placeholderText,
								'w-95 text-truncate': id == 'panel-slot',
							}"
						>
							{{ placeholderText ? selectedObject.label : placeholder }} </span
						><img
							:class="openDropdown ? 'rotate180' : ''"
							class="access-validationicon-2"
							src="../../assets/newdesign/inputcomponent/blueDownArrow.svg"
							alt=""
						/>
						<label
							id="hideinlaptop"
							class="selcus-floating-label"
							:class="{ active: isFocused || placeholderText }"
							>{{ label
							}}<span v-if="mandatory" class="asterik">&nbsp;*</span></label
						>
					</div>
				</template>
			</Popper>
		</div>
		<!-- <div class="select-div"></div> -->
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import Popper from "vue-popperjs";

export default {
	name: "SelectCustom",
	components: {
		Popper,
	},
	props: {
		noLabel: Boolean,
		mandatory: Boolean,
		dropdown: Boolean,
		showError: Boolean,
		label: String,
		placeholder: String,
		id: String,
		api: String,
		fieldType: String,
		values: Array,
		vmodel: {
			validator: function () {
				return true;
			},
		},
	},
	watch: {
		vmodel(newValue) {
			this.inputData = newValue;
			this.vmodel = newValue;
			this.selectOptionMethod();
		},
	},
	data() {
		return {
			openDropdown: false,
			isFocused: false,
			search: "",
			selectedValue: "",
			dropDownOptions: [],
			selectedObject: {},
			reRender: 0,
		};
	},
	computed: {
		...mapGetters("userVUEX", {
			licenseKey: "getlicenseKey",
		}),
		placeholderText() {
			return Object.keys(this.selectedObject).length > 0;
		},
	},
	created() {
		console.log("sel cust");
		if (this.dropdown) {
			this.dropDownOptions = this.values;
		} else {
			this.getDropdownOptions();
		}

		if (this.vmodel) {
			this.selectOptionMethod();
			this.$emit("select-value", this.selectedValue);
		} else {
			this.checkDefaultOption();
		}
	},
	mounted() {
		document.body.addEventListener("keydown", this.handleKeyPress);
	},
	beforeDestroy() {
		document.body.removeEventListener("keydown", this.handleKeyPress);
	},
	methods: {
		selectOptionMethod() {
			let type = typeof this.vmodel;

			this.selectedValue = type === "string" ? this.vmodel : this.vmodel.key;
			console.log(this.selectedValue, "selval");

			let selObject = this.dropDownOptions.find((obj) => {
				return obj.key === this.selectedValue;
			});
			if (selObject == undefined) {
				this.checkDefaultOption();
			} else {
				this.selectedObject = selObject;
			}
		},
		checkDefaultOption() {
			const defaultOption = this.dropDownOptions.find(
				(option) => option.isDefault
			);
			if (defaultOption) {
				this.selectedValue = defaultOption.key;
				this.selectedObject = defaultOption;
			}
		},
		handleKeyPress(event) {
			if (this.openDropdown) {
				const options = this.dropDownOptions;
				const selectedIndex = options.findIndex(
					(option) => option.key === this.selectedValue
				);
				if (event.key === "ArrowDown" && selectedIndex < options.length - 1) {
					this.selectedValue = options[selectedIndex + 1].key;
					this.selectedObject = options[selectedIndex + 1];
					const selectedOptionElement = document.getElementById(
						this.selectedValue
					);
					if (selectedOptionElement) {
						selectedOptionElement.scrollIntoView({
							behavior: "smooth",
							block: "nearest",
						});
					}
					this.$emit("select-value", this.selectedValue);
					event.preventDefault();
				} else if (event.key === "ArrowUp" && selectedIndex > 0) {
					this.selectedValue = options[selectedIndex - 1].key;
					this.selectedObject = options[selectedIndex - 1];
					const selectedOptionElement = document.getElementById(
						this.selectedValue
					);
					if (selectedOptionElement) {
						selectedOptionElement.scrollIntoView({
							behavior: "smooth",
							block: "nearest",
						});
					}
					this.$emit("select-value", this.selectedValue);
					event.preventDefault();
				} else if (event.key === "Enter") {
					this.hideLandingDropdown();
				}
			}
		},
		async getDropdownOptions() {
			this.dropDownOptions = [];
		},
		hideLandingDropdown() {
			this.reRender++;
			this.openDropdown = false;
		},

		isSelected(option) {
			return this.selectedObject && this.selectedObject.key === option.key;
		},
	},
};
</script>

<style scoped>
@media (max-width: 1028px) {
	.selectCustom-field .inputPlaceholder-font {
		color: #fff;
	}
}

.selectCustom-field {
	position: relative;
	padding-top: 12px; /* Adjust this space to ensure label doesn't overlap */
}

.selectCustom-opt-selected {
	background-color: #c8d9e5;
	font-size: 11px;
	color: #333;
	font-weight: 600;
	font-family: "Lato", sans-serif;
	border: none;
	text-align: left;
	padding: 8px 12px;
}

.selectCustom-opt-unselected {
	background: #f9f9f9;
	font-size: 11px;
	color: #333;
	font-weight: 600;
	font-family: "Lato", sans-serif;
	border: none;
	text-align: left;
	padding: 8px 12px;
}

.selectCustom-opt-unselected:hover {
	background-color: #e8eff4;
}
@media only screen and (max-width: 1028px) {
	.selectCustom-dropdown::-webkit-scrollbar {
		width: 5px !important;
		height: 5px !important;
	}
}
</style>
